import { styled } from 'styled-components'

import { ButtonAsA } from '@b-stock/fe-core/bstock-react'
import { Breakpoints, Colors, Typography } from '@b-stock/fe-core/design-system'

import { CarouselItemWrapper } from './Carousel'

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  padding: 3rem 1.5rem 0;

  @media ${Breakpoints.min.medium} {
    padding: 3rem 3rem 0;
  }
`

export const Container = styled.div`
  width: 100%;
  max-width: var(--maxPageWidth);
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  ${CarouselItemWrapper} {
    padding: 0 0.125rem;
  }
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`

export const TitleGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  /* Lets Subtitle's ellipsis truncation actually kick in — a flex item's
     default min-width is its content size, which would push Header wider
     instead of shrinking this group. */
  min-width: 0;
`

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0 0.125rem;
`

export const Subtitle = styled.p`
  ${Typography.Body3};
  color: ${Colors.Semantic.Neutral.dark_grey};
  margin: 0;
  padding: 0 0.125rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media ${Breakpoints.min.medium} {
    ${Typography.Body2};
  }
`

export const IconWrapper = styled.div`
  width: 1.5rem;
  height: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${Colors.Semantic.Info.onhover};
  font-size: 1.25rem;

  @media ${Breakpoints.max.medium} {
    width: 1.25rem;
    height: 1.25rem;
    font-size: 1rem;
  }
`

export const Title = styled.h2`
  ${Typography.Title3};
  color: ${Colors.Semantic.Neutral.light_black};
  margin: 0;

  @media ${Breakpoints.min.medium} {
    ${Typography.Title2};
  }
`

export const Count = styled.span`
  ${Typography.Body3};
  color: ${Colors.Semantic.Neutral.dark_grey};
  margin-left: 0.25rem;
  white-space: nowrap;

  @media ${Breakpoints.min.medium} {
    ${Typography.Body2};
  }
`

export const ViewAllButton = styled(ButtonAsA)`
  ${Typography.Body3_Semibold};
  color: ${Colors.Semantic.Neutral.light_black};
  white-space: nowrap;
  padding: 0;

  &&:hover {
    background-color: transparent;
    color: ${Colors.Semantic.Info.highlight};
  }

  @media ${Breakpoints.max.small} {
    display: none;
  }
`

export const ViewAllButtonMobile = styled(ViewAllButton)`
  display: none;

  @media ${Breakpoints.max.small} {
    display: block;
  }
`
